import { render, staticRenderFns } from "./LandingView.vue?vue&type=template&id=05a0a58c&scoped=true&"
import script from "./LandingView.vue?vue&type=script&lang=ts&"
export * from "./LandingView.vue?vue&type=script&lang=ts&"
import style0 from "./LandingView.vue?vue&type=style&index=0&id=05a0a58c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0a58c",
  null
  
)

export default component.exports